import React from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const ActionControls = ({ event, onTrigger }) => (
    <Box sx={{ display: 'flex', gap: 2 }}>
        <Tooltip
            title={
                <Typography fontSize={12}>
                    <strong>Approve:</strong> Confirm this decision. The system will execute it on its own.
                </Typography>
            }
        >
            <Button variant="outlined" color="warning" onClick={() => onTrigger('approve')}>
                Approve <InfoIcon sx={{ ml: 0.5, fontSize: 16 }} />
            </Button>
        </Tooltip>

        <Tooltip
            title={
                <Typography fontSize={12}>
                    <strong>Execute:</strong> Skip automation and do this now. Only use if urgent.
                </Typography>
            }
        >
            <Button variant="contained" color="success" onClick={() => onTrigger('execute')}>
                Execute <InfoIcon sx={{ ml: 0.5, fontSize: 16 }} />
            </Button>
        </Tooltip>

        <Button variant="outlined" color="error" onClick={() => onTrigger('deny')}>
            Deny
        </Button>
    </Box>
);

export default ActionControls;
